import { render, staticRenderFns } from "./pedidoVer.vue?vue&type=template&id=0d790f0d&"
import script from "./pedidoVer.vue?vue&type=script&lang=js&"
export * from "./pedidoVer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports